<template>
  <transition name="content-modal">
    <div
      v-if="isVisible"
      class="content-modal"
    >
      <nav class="content-nav">
        <ul class="content-nav__list content-nav__list--center">
          <li class="content-nav__item">
            <a
              v-if="isEdit"
              :class="contentModalLinkModeClasses"
              class="content-nav__link"
              @click.prevent="openContentModalLinkMode"
            >
              <font-awesome-icon
                icon="link"
                size="2x"
              />
            </a>
          </li>
          <li class="content-nav__item">
            <a
              :class="contentModalManualModeClasses"
              class="content-nav__link"
              @click.prevent="openContentModalManualMode"
            >
              <font-awesome-icon
                icon="pencil-alt"
                size="2x"
              />
            </a>
          </li>
        </ul>
        <ul class="content-nav__list content-nav__list--right">
          <li class="content-nav__item">
            <a
              class="content-nav__link"
              @click.prevent="closeContentModal"
            >
              <font-awesome-icon
                icon="times"
                size="2x"
              />
            </a>
          </li>
        </ul>
      </nav>
      <div>
        <page class="content-modal__container">
          <section-title v-show="contentModalIsLinkMode">Link hinzufügen</section-title>
          <section-title v-show="contentModalIsManualMode">{{ modalTitle }}</section-title>
          <div class="content-modal__content">
            <content-form
              v-show="!isFetching"
              ref="contentForm"
            />
            <div
              v-show="isFetching"
              class="content-modal__loader"
            >
              <div class="content-modal__sync-icon-wrap">
                <font-awesome-icon
                  icon="sync-alt"
                  size="6x"
                />
              </div>
              <span v-t="'c.contentModal.message.fetchData'"/>
            </div>
          </div>
        </page>
      </div>
      <div class="content-modal__form-actions">
        <div class="container">
          <div class="row">
            <div class="col-xs-6 col-lg-4 push-lg-2">
              <button-input
                v-t="'c.contentModal.form.action.submit'"
                :is-disabled="!isSaveable"
                class="content-modal__publish-button"
                type="submit"
                @click="handleSubmit"
              />
            </div>
            <div class="col-xs-6 col-lg-4 push-lg-2 text-right">
              <button-input
                v-t="'c.contentModal.form.action.cancel'"
                class="content-modal__cancel-button"
                color="grey"
                @click="closeContentModal"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import isBlank from 'is-blank'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import PageMixin from '@/mixins/pages/Page'
import ButtonInput from '@/components/ui/ButtonInput'
import ContentForm from './ContentForm'

export default {
  name: 'ContentModal',
  mixins: [PageMixin],
  components: {
    ButtonInput,
    ContentForm,
    FontAwesomeIcon
  },
  computed: {
    ...mapState({
      id: state => state.contentModal.id,
      mode: state => state.contentModal.mode,
      isFetching: state => state.contentForm.fetchUrlRequest.isLoading,
      isVisible: state => state.contentModal.isVisible,
      isEdit: state => isBlank(state.contentModal.id),
      modalTitle: state => isBlank(state.contentModal.id) ? 'Artikel hinzufügen' : 'Artikel bearbeiten'
    }),
    ...mapGetters({
      isSaveable: 'contentForm/isSaveable',
    }),
    ...mapGetters([
      'contentModalIsLinkMode',
      'contentModalIsManualMode'
    ]),
    contentModalLinkModeClasses () {
      return { 'content-nav__link--selected': this.contentModalIsLinkMode }
    },
    contentModalManualModeClasses () {
      return { 'content-nav__link--selected': this.contentModalIsManualMode }
    }
  },
  watch: {
    isVisible: {
      immediate: true,
      handler (isVisible) {
        if (isVisible) {
          document.querySelector('html').classList.add('noscroll')
        } else {
          document.querySelector('html').classList.remove('noscroll')
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'closeContentModal',
      'openContentModalLinkMode',
      'openContentModalManualMode'
    ]),
    handleSubmit () {
      const { contentForm } = this.$refs
      if (contentForm) {
        contentForm.handleSubmit()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contents/ContentModal.vue